import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/user/Login'
import Forgotpwd from '@/components/user/Forgotpwd'
import verifyStatus from '@/components/user/verifyStatus'
import Verify from '@/components/user/verify'
import PersonaIinfo from '@/components/user/personalInfo'
import Message from '@/components/message/message'
import Register from '@/components/register/register'
import Myclass from '@/components/myclass/myclass'
import Order from '@/components/orders/order'
import Pay from '@/components/pay/pay'
import Confirm from '@/components/pay/confirm'
import Paynow from '@/components/pay/paynow'
import Bosi from '@/components/pay/bosiExtraInfo'
import Hello from '@/components/HelloWorld'
import Assessment from '@/components/Assessment/Assessment'
import attendance from '@/components/attendance/attendance'
import AssessmentDetail from '@/components/Assessment/AssessmentDetail'
import Info from '@/components/Info/Info'
import Survey from '@/components/Survey/Survey'
import Surveys from '@/components/Survey/Surveysuccess'
import NonTax from '@/components/pay/nonTax'
Vue.use(Router)
var router = new Router({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/oreg' : '/',
    //base: process.env.VUE_APP_API_URL,
    routes: [{
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/Survey',
            name: 'Survey',
            component: Survey,
        },
        {
            path: '/verifyStatus',
            name: 'verifyStatus',
            component: verifyStatus,
        },

        {
            path: '/Surveys',
            name: 'Surveys',
            component: Surveys,
        },
        {
            path: '/forgotpwd',
            name: 'forgotpwd',
            component: Forgotpwd,

        },
        {
            path: '/Info',
            name: 'Info',
            component: Info,

        },
        {
            path: '/attendance',
            name: 'attendance',
            component: attendance,
        },
        {
            path: '/AssessmentDetail',
            name: 'AssessmentDetail',
            component: AssessmentDetail,

        },
        {
            path: '/Assessment',
            name: 'Assessment',
            component: Assessment,

        },
        {
            path: '/verify',
            name: 'verify',
            component: Verify
        },
        {
            path: '/message',
            name: 'message',
            component: Message
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/hello',
            name: 'hello',
            component: Hello,
        },
        {
            path: '/myclass',
            name: 'Myclass',
            component: Myclass,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },

        {
            path: '/pay',
            name: 'Pay',
            component: Pay,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/confirm',
            name: 'Confirm',
            component: Confirm,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/paynow',
            name: 'Paynow',
            component: Paynow,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/bosi',
            name: 'Bosi',
            component: Bosi,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
        {
            path: '/personalinfo',
            name: 'personalinfo',
            component: PersonaIinfo
        },
        {
            path: '/nonTax',
            name: 'nonTax',
            component: NonTax,
            meta: {
                keepAlive: false, //此组件需要被缓存   
            }
        },
    ]
});
router.beforeEach(function(to, from, next) {

    let token = window.sessionStorage.getItem("access_token");
    if (to.name != "login" && to.name != "forgotpwd" && to.name != 'Info' && to.name != 'Survey' && to.name != 'Surveys') {
        if (token && token != undefined && token != "undefined") {
            if (to.name == null) {
                next({ name: 'login' })
            } else {
                next();
            }
        } else {
            next({ name: 'login' });
        }
    } else if (to.name == 'Survey') {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        if (flag || to.query.ismobile) {
            location.href = 'http://120.77.227.46/wreg' + to.fullPath;
        } else {
            next();
        }
    } else {
        next();

    }
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js